module.exports = [
	{
		"name": "unity",
		"title": "Games, Apps, VR, AR",
		"logo": "images/unity-logo.png",
		"description": "I've worked on multiple projects made with Unity, both commercial and for fun. There were games (High Noon 2), apps (Leapfrog Aspect AR), Unity plugins (Splitforce), and multitude of projects for research (behavioural AI, procedural levels, flocking AI)",
		"image_name": "images/unity.jpg"
	},
	{
		"name": "mobile",
		"title": "Mobile",
		"logo": "images/mobile-logo.png",
		"description": "My mobile sampler include app with highly sensitive data for stocks, location based tracker for workers, React Native offline guide, multipeer local game and multiple utility apps.",
		"image_name": "images/mobile.jpg"
	},
	{
		"name": "web",
		"title": "Web, Server side",
		"logo": "images/browser-logo.png",
		"description": "My to-go web stack is Rails or, for smaller projects, Sinatra. I've done multiple RoR, Node, SPA apps. For the backend I worked with setting and maintaing productions servers, optimizing servers and databases, working as a Live team member on 24h support.",
		"image_name": "images/browser.jpg"
	},
	{
		"name": "others",
		"title": "Hardware, Fun, Research, AI, DNN",
		"logo": "images/others-logo.png",
		"description": "I try to test new tech to see how can I use it in future projects. This section includes various other experiences that didn't fit above, like being Scrum Master, Android + Motobike ECU, Person Recognition, Sleep tracker + IFTT for automatic morning coffee, Sound Controlled Fighter Game and multiple others.",
		"image_name": "images/others.jpg"
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/projects/projects.json
 ** module id = 116
 ** module chunks = 0
 **/